import React from 'react';

interface VectorGhostProps {
  className?: string;
  color?: string;
  isCaught?: boolean;
  /** Biểu cảm "ngạc nhiên/trúng đòn" khi bị click nhưng vẫn còn mạng */
  isHit?: boolean;
  /** Ma 7 màu rainbow */
  isRainbow?: boolean;
  /** Khi truyền iconSize (px), ghost render như một icon inline thay vì ghost bay lơ lửng */
  iconSize?: number;
}

const VectorGhost = ({ className = '', color = '#FEFFFE', isCaught = false, isHit = false, isRainbow = false, iconSize }: VectorGhostProps) => {
  const isIcon = iconSize !== undefined;
  const size = iconSize ?? 30;

  const iconStyle: React.CSSProperties | undefined = isIcon
    ? {
      position: 'relative',
      top: 'auto',
      bottom: 'auto',
      left: 'auto',
      right: 'auto',
      width: size,
      height: size,
      display: 'inline-block',
      flexShrink: 0,
      filter: 'drop-shadow(0 1px 3px rgba(0, 0, 0, 0.4))',
    }
    : undefined;

  return (
    <svg
      className={`${className} ${iconSize ? "svgIcon" : ""}`}
      style={iconStyle}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="55 40 150 190"
      fill="none"
    >
      <defs>
        <linearGradient
          id="ghost-rainbow-body-gradient"
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%"
          spreadMethod="repeat"
        >
          <stop offset="0%" stopColor="#ff0055" />
          <stop offset="14.28%" stopColor="#ff7700" />
          <stop offset="28.57%" stopColor="#ffdd00" />
          <stop offset="42.85%" stopColor="#00e676" />
          <stop offset="57.14%" stopColor="#00b0ff" />
          <stop offset="71.42%" stopColor="#5338ff" />
          <stop offset="85.71%" stopColor="#c500ff" />
          <stop offset="100%" stopColor="#ff0055" />

          <animate attributeName="y1" values="0%;-100%" dur="3s" repeatCount="indefinite" />
          <animate attributeName="y2" values="100%;0%" dur="3s" repeatCount="indefinite" />
        </linearGradient>
      </defs>

      {/* Ghost Body */}
      <path
        d="m195.9 107.8c-2.84-27.64-18.85-62.98-60.73-64.4h-3.09c-29.9 0-52.18 21.88-56.84 52.31-2.68 9.26-2.46 20.79-4.86 35.12-2.48 14.9-7.38 20.23-10.77 28.96-1.88 5.11-1.19 17.58 10.84 18.65 6.63 0.59 14.92-2.78 15.03-3.96-2.25 4.59-5.08 12.84-4.78 19.82 0.6 11.64 8.71 17.78 21.25 17.78 14.07 0 24.1-8.4 30.32-12.14 3.01 7.78 6.93 12.14 14.41 12.14 13.02 0 27.47-13.13 33.84-23.58 11.19-19.55 18.26-42.4 16.17-71.32-0.08-2.87-0.35-6.08-0.79-9.38z"
        fill={isRainbow ? "url(#ghost-rainbow-body-gradient)" : color}
      />

      {isCaught ? (
        <g stroke="#010202" strokeWidth="5.5" strokeLinecap="round">
          {/* Left Eye: X */}
          <line x1="126" y1="96" x2="144" y2="114" />
          <line x1="144" y1="96" x2="126" y2="114" />

          {/* Right Eye: X */}
          <line x1="155" y1="96" x2="173" y2="114" />
          <line x1="173" y1="96" x2="155" y2="114" />

          {/* Cute Surprise Mouth */}
          <ellipse cx="149.5" cy="138" rx="6" ry="8" fill="#010202" stroke="none" />
        </g>
      ) : isHit ? (
        <g fill="#010202">
          {/* Mắt tròn ngạc nhiên */}
          <circle cx="135" cy="104" r="8.5" />
          <circle cx="164" cy="104" r="8.5" />
          {/* Miệng "O" há tròn (😮) */}
          <ellipse cx="149.5" cy="140" rx="12" ry="14" />
        </g>
      ) : (
        <>
          {/* Normal Eyes */}
          <path
            d="m135.1 90.55c-7.28-0.54-7.85 8.36-7.85 14.05 0 6.08 1.6 13.14 7.96 13.14 6.6 0 8.92-8.08 8.92-13.14 0-5.56-1.59-14.05-9.03-14.05z"
            fill="#010202"
          />
          <path
            d="m164.4 90.55c-7.27-0.54-8.66 7.59-8.66 14.05 0 5.82 1.51 13.14 8.07 13.14 7.38 0 8.83-9.57 8.83-13.14 0-5.89-2.01-14.05-8.24-14.05z"
            fill="#010202"
          />
        </>
      )}
    </svg>
  );
};

export default React.memo(VectorGhost);